import { SwitchVertical } from '@ui/components/icons';
import { Button } from '@ui/lib/park/ui/button';
import { Icon } from '@ui/lib/park/ui/icon';
import { useContext } from 'react';
import { Box } from 'styled-system/jsx';

import { ExchangeContext } from './Context';

export const SwitchButton = () => {
  const { inputToken, outputToken, setInputToken, setOutputToken } = useContext(ExchangeContext);

  const handleSwitch = () => {
    if (inputToken && outputToken) {
      setInputToken(outputToken);
      setOutputToken(inputToken);
    }
  };

  return (
    <Box position="relative" h="4px" w="full" display="flex" alignItems="center" justifyContent="center" zIndex={1}>
      <Button
        variant="ghost"
        size="mid"
        p={2}
        minW="0"
        borderRadius="4px"
        onClick={handleSwitch}
        display="flex"
        alignItems="center"
        justifyContent="center"
        bg="#222222"
        border="2px solid #272727"
        _hover={{
          cursor: 'pointer',
          bg: '#262626',
          borderColor: '#494949',
        }}
        _active={{
          bg: '#2b2b2b',
          borderColor: '#5a5a5a',
        }}
      >
        <Icon
          boxSize="20px"
          color="greyWhite.lightGrey3"
          transform="rotate(90deg)"
          _groupHover={{ color: 'greyWhite.lightGrey1' }}
        >
          <SwitchVertical />
        </Icon>
      </Button>
    </Box>
  );
};
